export default {
	zhifujieguoyanzhengzhong: '支付结果正在验证中，请您耐心等待。',
	zhengzaiweininchaxun: '正在为您查询，感谢您的耐心等待',
	qingshuruhuoxuanzenidechengshi: '请输入或选择您的目的地',
	qingshuruchufadidian: '请输入出发地点!',
	qingshurumudidi: '请输入目的地!',
	qinglijiyuwomenlianxin: '请立即与我们联系，以获得任何查询或预订帮助。',
	lijiyuwomenliaotian: '立即与我们聊天',
	xuyaobangzhuma: '需要帮助吗？',
	kehufuwurexian: '客户服务热线',
	geiwomenfadianziyoujian: '给我们发电子邮件',
	chaxunbiaoge: '联系表',
	songxinren: 'Messenger',
	xingming: '姓名',
	gongsimingcheng: '公司名称',
	youjiandizhi: '电子邮件地址',
	lianxidianhua: '联系电话',
	zhuti: '主题',
	liuyan: '留言',
	tijiao: '提交',
	lianxiwomen: '联系我们',
	shouyetishixinxi: '*以上价格仅适用于经济舱的回程航班。实际价格可能有所不同。适用条款和条件。',
	shangyiye: '上一頁',
	xiayiye: '下一頁',
	fangda: '放大',
	suoxiao: '缩小',
	shengdantishi: '提交订单失败，返回搜索结果页重新搜索',
	qushouye: '去首页',
	hangbanyishouqing: '航班已售罄',
	zhifushibai: '支付失败',
	zhifuchaoshi: '支付超时',
	chongxinzhifu: '重新支付',
	yudingshibai: '预定失败',
	dingdanzhengzaichulizhong: '订单正在处理中，请稍后刷新查看状态！',
	yiwancheng: '已完成',
	zhifufangshi: '支付方式'
};
